import * as React from "react";
import {
  ExistingControlIcon,
  ExistingControlIconState,
  FirstExistingControlIcon,
  FirstExistingControlIconState,
} from "@traceair/webapp-icons";

export interface IExistingControlMarkerIconParams {
  isExistingHighPrio?: boolean;
  isSelected?: boolean;
}

// EC and EC-first icons render identically on the map and in the sidebar,
// so both areas share this single rendering source.
export const ExistingControlMarkerIcon = (
  params: IExistingControlMarkerIconParams,
) => {
  if (params.isExistingHighPrio) {
    return (
      <FirstExistingControlIcon
        state={
          params.isSelected
            ? FirstExistingControlIconState.Active
            : FirstExistingControlIconState.Default
        }
      />
    );
  }
  return (
    <ExistingControlIcon
      state={
        params.isSelected
          ? ExistingControlIconState.Active
          : ExistingControlIconState.Default
      }
    />
  );
};
